<template>
  <Sidebar />
  <Content :class="['storefront-page', is_empty && ' storefront-empty']" v-loading="loading">
    <header class="creator-header">
      <div class="title">
        <h2>{{ title }}</h2>
        <queue-progress />
      </div>
      <el-button v-if="route.params.id === 'products' && !is_empty" type="primary" @click="addProduct">
        <svg-icon name="plus" />Add products
      </el-button>
      <el-button v-else-if="route.params.id === 'collections' && !is_empty" type="primary"
        @click="EventBus.emit('open-collection-edit-dialog', { id: 1, row: null, which: 'collection' })">
        <svg-icon name="plus" />New
      </el-button>
    </header>

    <div v-if="!is_empty" class="data-height-box">
      <ProductsTable v-if="route.params.id === 'products'" @isProductEmpty="getEmpty" />
      <CollectionsTable v-else-if="route.params.id === 'collections'" @isCollectionEmpty="getEmpty" />
    </div>

    <Empty v-if="is_empty">
      <el-button type="primary" v-if="route.params.id === 'products'" @click="addProduct">Add first product</el-button>
      <el-button type="primary" v-else-if="route.params.id === 'collections'"
        @click="EventBus.emit('open-collection-edit-dialog', { id: 1, row: null, which: 'collection' })">Create first
        collection</el-button>
    </Empty>
  </Content>


  <CollectionDetailDrawer ref="collection_detail_drawer_el" @tag-product="tagProducts" @open-manage="manageProducts"
    @move="move" :merchant_account_id="storefront?.id" :merchant_display_name="storefront?.merchant_display_name"
    :tag_type="tag_product_type" v-loading="loading" />

  <manage-content-drawer ref="manage_content_drawer_el" :manage_type="tag_product_type"
    :merchant_account_id="storefront?.id" :manage_content_id="tag_product_content_id" @update="updateData()"
    @move="move" @delete="RemoveItem" />

  <CollectionAddEditPopup />
  <TagProducts />
  <RecipientDialog />
  <AddProductToCollections />
  <confirm-dialog ref="confirm_dialog_el" :data="confirm_data" />

  <el-dialog v-model="collectionDialogValue.show" width="350px" :show-close="false"
    class="storefront-handle-check-dialog">
    <div class="title">{{ collectionDialogValue.title }}</div>
    <div class="text" v-html="collectionDialogValue.text"></div>

    <div class="btn-box">
      <el-button @click="collectionDialogValue.show = false">Cancel</el-button>
      <el-button type="primary" @click="confirmCollectionDialog">Confirm</el-button>
    </div>
  </el-dialog>

  <el-dialog v-model="productDialogValue.show" width="350px" :show-close="false" class="storefront-handle-check-dialog">
    <div class="title">{{ productDialogValue.title }}</div>
    <div class="text">{{ productDialogValue.text }}</div>

    <div class="btn-box">
      <el-button @click="productDialogValue.show = false">Cancel</el-button>
      <el-button type="primary" @click="confirmProductDialog">Confirm</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import Sidebar from '@/components/Sidebar.vue';
import { ref, onMounted, getCurrentInstance, computed, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import { useRoute, useRouter } from 'vue-router';
import CollectionsTable from '@/components/storefront/CollectionsTable.vue';
import ProductsTable from '@/components/storefront/ProductsTable.vue';
import Empty from '@/components/storefront/Empty.vue';
import Content from '@/components/ui/Content.vue';
import { ElButton, ElDialog } from 'element-plus';
import CollectionAddEditPopup from '@/components/storefront/CollectionAddEditPopup.vue';
import RecipientDialog from '@/components/storefront/RecipientDialog.vue';
import TagProducts from '@/components/tag/Index.vue';
import { useNotification } from '@/components/ui/notification';
import CollectionDetailDrawer from '@/components/storefront/collectionDetail/CollectionDetailDrawer.vue';
import ManageContentDrawer from '@/components/storefront/collectionDetail/ManageContentDrawer.vue';
import Loading from '@/components/ui/Loading.vue';
import AddProductToCollections from '@/components/storefront/collectionDetail/AddProductToCollections.vue';
import ConfirmDialog from '@/components/storefront/collectionDetail/ConfirmDialog.vue';
import { useStorefrontFunction } from '@/components/storefront/StorefrontFunction.js';

const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;
const { STATUS_CODE } = useStorefrontFunction();
const { openNotBottom } = useNotification();
const store = useStore();
const route = useRoute();
const router = useRouter();
const is_empty = ref(false);
const title = computed(() => {
  if (route.params.id === 'products') {
    return 'Curated Products';
  } else if (route.params.id === 'collections') {
    return 'Curated Collections ';
  }
});

const collectionDialogValue = ref({
  show: false,
  type: 'Publish',
  text: '',
  title: ''
});

const DoCollectionRow = ref([]);
const loading = ref(false);

const productDialogValue = ref({
  show: false,
  type: 'Publish',
  text: '',
  title: ''
});

const DoProdcutRow = ref([]);
const DoProdcutCallback = ref(null);

//move form cp
const tag_product_type = ref('storefront');
const tag_product_content_id = ref(null);
const collection_detail_drawer_el = ref(null);
const manage_content_drawer_el = ref(null);
const confirm_data = ref({
  title: '',
  description: '',
  action: () => { },
});
const confirm_dialog_el = ref(null);
const storefront = computed(() => {
  return store.state.user_data.merchant_account;
});

watch(() => route.params.id, (newVal) => {
  is_empty.value = false;
}, { immediate: true })
//+++++++++++++++++++++++++++++++++
const addProduct = () => {
  eventBus.emit('tag-products', { id: 0, which: 'storefront' });
};

//++++++++++++++++++++++++++++++++++++++++++++
//collection function
//++++++++++++++++++++++++
const handleCollectionHandleDialog = (type, val = []) => {
  let pickText = `${DoCollectionRow.value.length > 1 ? 'selected' : 'this'}`;
  let countText = `${DoCollectionRow.value.length} collection${DoCollectionRow.value.length > 1 ? 's' : ''}`;
  let templates = {
    Publish: {
      title: `Publish ${pickText} collection?`,
      text: 'This will display the collection on all selected creators’ storefronts immediately.'
    },
    Disabled: {
      title: `Disable ${pickText} collection?`,
      //text: 'This will hide the collection on all selected creators’ storefronts immediately.'
      text: `This action will override ${countText} scheduled date to disable at {Date} {Time} and will hide the collection${DoCollectionRow.value.length > 1 ? 's' : ''} on all selected creators’ storefronts immediately.`
    },
    //
    PublishSchedule: {
      title: `Publish ${pickText} collection immediately?`,
      text: `This action will override ${countText} scheduled date to publish at {Date} {Time} and will display the collection${DoCollectionRow.value.length > 1 ? 's' : ''} on all selected creators’ storefronts immediately.`
    },
    DisabledSchedule: {
      title: `Disable ${pickText} collection ahead of the schedule?`,
      text: `This action will override ${countText} scheduled date to disable at {Date} {Time} and will hide the collection${DoCollectionRow.value.length > 1 ? 's' : ''} on all selected creators’ storefronts immediately.`
    },
    //
    PublishDraftToSchedule: {
      title: `Publish ${pickText} collection as schedule?`,
      text: `The collections will be publicly available on all selected creators’ storefronts on {Date} at {Time}.`
    },
    Delete: {
      title: 'Delete this draft permanently?',
      text: 'This action cannot be undone.'
    },
    Feature: {
      title: `Feature ${pickText} collection?`,
      text: 'This will highlight the collection on all selected creators’ storefronts immediately.'
    },
    Unfeature: {
      title: `Unfeature ${pickText} collection?`,
      text: 'Featured collection(s) are displayed prominently on a storefront homepage.'
    },
    Duplicate: {
      title: `Duplicate ${pickText} collection?`,
      text: 'This will create a copy of the collection as a draft.'
    },
  }

  const template = templates[type]
  if (!template) return null

  // For scheduled actions, use the collection's actual scheduled time
  // For immediate actions, use current time
  let dateToShow, timeToShow;

  if ((type === 'PublishDraftToSchedule' || type === 'DisabledSchedule') && val.length > 0 && val[0].publish_datetime) {
    const scheduledMoment = moment(val[0].publish_datetime);
    dateToShow = scheduledMoment.format('MMM DD, YYYY');
    timeToShow = scheduledMoment.format('hh:mm A');
  } else {
    dateToShow = moment().format('MMM DD, YYYY');
    timeToShow = moment().format('hh:mm A');
  };

  // 🆕 特殊邏輯：當 type 是 PublishSchedule 且為複數時，檢查每筆 status
  if (type === 'PublishSchedule' && DoCollectionRow.value.length > 1) {
    const validList = DoCollectionRow.value.filter(item =>
      (item.status === STATUS_CODE.Draft || item.status === STATUS_CODE.Disabled) && item.publish_datetime
    );
    const invalidList = DoCollectionRow.value.filter(item =>
      !(item.status === STATUS_CODE.Draft || item.status === STATUS_CODE.Disabled && item.publish_datetime)
    );

    if (validList.length > 0 || invalidList.length > 0) {
      template.title = `Publish ${pickText} collection?`;

      let textParts = [];

      if (validList.length > 0) {
        textParts.push(
          `${validList.length} collection${validList.length > 1 ? 's' : ''} will be publicly available on all selected creators’ storefronts on their scheduled datetime.`
        );
      }

      if (invalidList.length > 0) {
        textParts.push(
          `${invalidList.length} collection${invalidList.length > 1 ? 's' : ''} will override collections’ scheduled date to publish at {Date} {Time} and will display the collections on all selected creators’ storefronts immediately.`
        );
      }

      template.text = textParts.join('<br><br>'); // 若你的彈窗支援 HTML，可改成這行
    }
  }

  let text = template.text
    .replace('<#>', val.length)
    .replace('{Date}', dateToShow)
    .replace('{Time}', timeToShow)

  collectionDialogValue.value = {
    show: true,
    type,
    title: template.title,
    text
  }
  // console.log('collectionDialogValue.value', collectionDialogValue.value)
};

const handleOpenCollection = (val) => {
  DoCollectionRow.value = val.data;
  handleCollectionHandleDialog(val.type, val.data);
};

const confirmCollectionDialog = () => {
  collectionDialogValue.value.show = false;
  let params_data = {};
  if (collectionDialogValue.value.type === 'Duplicate') {
    params_data = {
      'curation_collection_id': DoCollectionRow.value[0].id
    };
  } else {
    params_data = {
      'curation_collection_ids[]': DoCollectionRow.value.map(e => e.id),
    };
  }

  const actions = {
    Publish: { url: '/storefront-curation/publish-curation-collection', msg: 'published' },
    Disabled: { url: '/storefront-curation/disable-curation-collection', msg: 'disabled' },
    PublishSchedule: { url: '/storefront-curation/publish-curation-collection', msg: 'published' },
    DisabledSchedule: { url: '/storefront-curation/disable-curation-collection', msg: 'disabled' },
    PublishDraftToSchedule: { url: '/storefront-curation/publish-curation-collection', msg: 'published' },
    Delete: { url: '/storefront-curation/delete-curation-collection', msg: 'deleted' },
    DeleteMetadata: { url: '/storefront-curation/delete-curation-collection', msg: 'deleted' },
    Feature: { url: '/storefront-curation/feature-curation-collection', msg: 'featured' },
    Unfeature: { url: '/storefront-curation/unfeature-curation-collection', msg: 'unfeatured' },
    Duplicate: { url: '/storefront-curation/duplicate-curation-collection', msg: 'duplicated' },
  };

  const action = actions[collectionDialogValue.value.type];
  if (action) {
    handleCollectionAction(action.url, params_data, action.msg, collectionDialogValue.value.type);
  }
};

const handleCollectionAction = (url, params, msg, actionType) => {
  if (!url) {
    openNotBottom(
      `Collection${DoCollectionRow.value.length !== 1 ? 's' : ''} ${msg}`,
      'success'
    );
    return;
  }
  loading.value = true;
  ajax.post(url, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((response) => {
    eventBus.emit('refresh-storefront-collection-table');
    
    if (DoProdcutCallback.value) {
      DoProdcutCallback.value();
      DoProdcutCallback.value = null;
    }
    loading.value = false;
    openNotBottom(
      `Collection${DoCollectionRow.value.length !== 1 ? 's' : ''} ${msg}`,
      'success'
    );
    
    // Trigger queue update event for specific actions
    const queueActions = ['Publish', 'Disabled', 'Feature', 'Delete', 'Unfeature'];

    if (queueActions.includes(actionType)) {
      eventBus.emit('ready-queue-update');
    }
  });
};


//++++++++++++++++++++++++++++++++++++++++++++
//product function
//++++++++++++++++++++++++++++++++++++++++++++
const handleProductHandleDialog = (type, val = []) => {
  let pickText = `${DoProdcutRow.value.length > 1 ? 'selected' : 'this'}`;
  let countText = `${DoProdcutRow.value.length} product${DoProdcutRow.value.length > 1 ? 's' : ''}`;
  let templates = {
    Publish: {
      title: `Publish ${pickText} product?`,
      text: 'This will display the product on all selected creators storefronts now.'
    },
    PublishDraftToSchedule: {
      title: `Publish ${pickText} product?`,
      text: 'This will display the product on all selected creators storefronts {Date} {Time}.'
    },
    Disabled: {
      title: `Disable ${pickText} product?`,
      text: 'This will hide the product on all selected creators storefronts immediately.'
    },
    //
    PublishSchedule: {
      title: `Publish ${pickText} product immediately?`,
      text: `This action will override ${countText} scheduled date to publish at {Date} {Time} and will display the product${DoCollectionRow.value.length > 1 ? 's' : ''} on all selected creators’ storefronts immediately.`
    },
    DisabledSchedule: {
      title: `Disable ${pickText} product ahead of the schedule?`,
      text: `This action will override ${countText} scheduled date to disable at {Date} {Time} and will hide the product${DoCollectionRow.value.length > 1 ? 's' : ''} on all selected creators’ storefronts immediately.`
    },
    Delete: {
      title: 'Delete this draft permanently?',
      text: 'This action cannot be undone.'
    },
    Feature: {
      title: `Feature ${pickText} product?`,
      text: 'This will highlight the product on all selected creators storefronts immediately.'
    },
    Unfeature: {
      title: `Unfeature ${pickText} product?`,
      text: 'Featured product(s) are displayed prominently on a storefront homepage.'
    },
  }

  const template = templates[type]
  if (!template) return null

  let dateToShow, timeToShow;
  if ((type === 'PublishDraftToSchedule' || type === 'DisabledSchedule') && val.length > 0 && val[0].publish_datetime) {
    const scheduledMoment = moment(val[0].publish_datetime);
    dateToShow = scheduledMoment.format('MMM DD, YYYY');
    timeToShow = scheduledMoment.format('hh:mm A');
  } else {
    dateToShow = moment().format('MMM DD, YYYY');
    timeToShow = moment().format('hh:mm A');
  };

 let text = template.text
  .replace('<#>', val.length)
  .replace('{Date}', dateToShow)
  .replace('{Time}', timeToShow)


  productDialogValue.value = {
    show: true,
    type,
    title: template.title,
    text
  }
};

const handleOpenProduct = (val) => {
  DoProdcutRow.value = val.data;
  DoProdcutCallback.value = val.callback || null;
  handleProductHandleDialog(val.type, val.data);
};

const confirmProductDialog = () => {
  productDialogValue.value.show = false;
  const params_data = {
    'curation_product_ids[]': DoProdcutRow.value.map(e => e.id),
  };

  const actions = {
    Publish: { url: '/storefront-curation/publish-curation-product', msg: 'published' },
    Disabled: { url: '/storefront-curation/disable-curation-product', msg: 'disabled' },
    PublishSchedule: { url: '/storefront-curation/publish-curation-product', msg: 'published' },
    DisabledSchedule: { url: '/storefront-curation/disable-curation-product', msg: 'disabled' },
    Delete: { url: '/storefront-curation/delete-curation-product', msg: 'deleted' },
    DeleteMetadata: { url: '/storefront-curation/delete-curation-product', msg: 'deleted' },
    Feature: { url: '/storefront-curation/feature-curation-product', msg: 'featured' },
    Unfeature: { url: '/storefront-curation/unfeature-curation-product', msg: 'unfeatured' },
  };

  const action = actions[productDialogValue.value.type];
  if (action) {
    handleProductAction(action.url, params_data, action.msg, productDialogValue.value.type);
  }
};

const handleProductAction = (url, params, msg, actionType) => {
  if (!url) {
    openNotBottom(
      `Product${DoProdcutRow.value.length !== 1 ? 's' : ''} ${msg}`,
      'success'
    );
    return;
  }
  loading.value = true;
  ajax.post(url, params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((response) => {
    eventBus.emit('refresh-storefront-product-table');
    if (DoProdcutCallback.value) {
      DoProdcutCallback.value();
      DoProdcutCallback.value = null;
    }
    loading.value = false;
    openNotBottom(
      `Product${DoProdcutRow.value.length !== 1 ? 's' : ''} ${msg}`,
      'success'
    );
    
    // Trigger queue update event for specific actions
    const queueActions = ['Publish', 'Disabled', 'Feature', 'Delete', 'Unfeature'];
    if (queueActions.includes(actionType)) {
      const jobId = response?.data?.data?.job_id || response?.data?.job_id || `product-${actionType.toLowerCase()}-${Date.now()}`;
      eventBus.emit('ready-queue-update', { jobId });
    }
  });
};


//move from cp
const tagProducts = (item) => {
  eventBus.emit('tag-products', { id: item.id, which: 'collection' });
};
const manageProducts = (item) => {
  tag_product_type.value = 'product'//item.type;
  tag_product_content_id.value = item.id;
  manage_content_drawer_el.value.open(item);
};

const move = (obj) => {
  // console.log(obj)
  let ids = [];
  const direction = obj.direction;
  const distance = obj.distance;
  const move_type = obj.type;
  const params = new URLSearchParams(window.location.search);
  const id = params.get('id');
  let api = '';
  let fdata = {
    curation_collection_id: id,
    action: direction,
  };

  if (obj.ids) {
    ids = obj.ids;
  } else {
    ids = move_type === 'product' ? [obj.product_id] : [obj.id];
  }

  let text = '';



  api = '/storefront-curation/update-curation-collection-item-sort';
  fdata.product_ids = ids;
  text = `${ids.length} product${ids.length > 1 ? 's' : ''} moved`;


  if (direction === 'up' || direction === 'down') {
    fdata.move_count = distance;
  }

  ajax.post(api, fdata).then((res) => {
    openNotBottom(text, 'success');

    if (typeof obj.cb === 'function') {
      obj.cb();
      updateData();
    }
    eventBus.emit('refresh-tagged-products');
  });
};

const updateData = (is_next = false) => {
};

const RemoveItem = (obj) => {
  let notification_text = '';
  let ids = [];
  const delete_type = obj.type;
  const is_selected = obj.is_selected || false;

  if (obj.ids) {
    ids = obj.ids;
  } else {
    ids = delete_type === 'product' ? [obj.product_id] : [obj.id];
  }

  switch (delete_type) {
    case 'product':
      notification_text = is_selected ? 'Product(s) remove' : 'Product remove';
      confirm_data.value = {
        title: `Are you sure you want to remove ${ids.length === 1 ? 'this product' : 'these products'} from this collection?`,
        description: `You will be removing ${ids.length} product${ids.length === 1 ? '' : 's'}.`,
      };
      break;
  }

  confirm_data.value.action = () => {
    if (obj.cbStart) {
      obj.cbStart();
    }
    const params = new URLSearchParams(window.location.search);
    const id = params.get('id');
    const form_data = {
      'product_ids': ids,
      'curation_collection_ids': [id],
    };

    let api_url = '';

    switch (delete_type) {
      case 'product':
        form_data.product_ids = ids;
        api_url = '/storefront-curation/remove-curation-collection-item';
        break;
    }

    ajax.post(api_url, form_data).then((res) => {
      eventBus.emit('refresh-storefront-collection-table');
      eventBus.emit('openAgain-manage');
      if (typeof obj.cbEnd === 'function') {
        obj.cbEnd();
      }

      if (DoProdcutCallback.value) {
        DoProdcutCallback.value();
        DoProdcutCallback.value = null;
      }
      openNotBottom(notification_text, 'success');

      //collection_detail_drawer_el.value.close();
    });
  };

  confirm_dialog_el.value.open();
};
//+++++++++++++++++++++++++++++++++++++++++++++++
const getEmpty = (val) => {
  is_empty.value = val;
};

onMounted(() => {
  eventBus.on('open-storefront-collection-handle-dialog', handleOpenCollection);
  eventBus.on('open-storefront-product-handle-dialog', handleOpenProduct);
  if (!storefront.value?.is_enable_storefront_curation) {
    router.push('/creator/list');
    return;
  };

  eventBus.on('set-not-empty', () => {
    // console.log("?", is_empty.value)
    if (is_empty.value) is_empty.value = false;
  });
});

onBeforeUnmount(() => {
  eventBus.off('open-storefront-collection-handle-dialog', handleOpenCollection);
  eventBus.off('open-storefront-product-handle-dialog', handleOpenProduct);
  eventBus.off('set-not-empty');
});
</script>
<style lang="scss">
.storefront-page {
  padding: 24px 48px;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 100%;
  overflow: hidden;

  &.storefront-empty {
    background: var(--black-10);
  }

  .data-height-box {
    height: calc(100% - 16px); //calc(100vh - 78px);
    overflow: auto;
    margin: 16px 0;
    display: grid;
    grid-template-rows: auto auto 1fr;
    grid-template-columns: 100%;

    .data-list {
      max-height: calc(95vh - 150px);

      thead {
        position: sticky;
        top: 0;
        z-index: 10;
        background: var(--white);
      }
    }

    .filter-results {
      margin: 0 0 16px;
    }

    .top {
      display: flex;
      align-items: center;
      padding: 16px 0;

      .ui-search {
        flex: 1;
        padding: 0 10px;

        .ui-search-input .input {
          max-width: unset;
        }
      }

      .left {
        display: flex;
        align-items: center;
        position: relative;

        .el-button--normal {
          background-color: var(--black-00);
          border-color: var(--text-primary);
        }
      }

      .right {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .ui-dropdown {
        .ui-button {
          border-color: var(--black-10);
          background-color: var(--black-10);
        }
      }

      .dropdown-programs {
        .ui-dropdown--inner .item-box {
          max-width: 220px;

          .select-icon {
            min-width: 12px;
          }
        }
      }
    }

    .svg-td {
      display: flex;
      justify-content: center;
    }

    .svg-icon {
      width: 16px;
      height: 16px;

      &.svg-icon--pen,
      &.svg-icon--menu {
        cursor: pointer;
      }

      &.svg-icon--arrow{
        width: 12px;
        height: 12px;
      }
    }

    .user-name {
      font: var(--font-med-12);
    }

    .desc {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 14px;
      white-space: initial;
    }

    .rec-td {
      display: flex;
      gap: 12px;
      align-items: center;

      .small-badage {
        color: var(--black-90);
        display: flex;
        padding: 4px 5px;
        font: var(--font-med-12);
        background-color: var(--bg-03);

        .svg-icon {
          width: 14px;
          height: 14px;
        }
      }
    }

    .badage-flex{
      display: flex;
      gap:6px;
    }

    .date-text {
      font-size: 12px;
      margin-top: 4px;
    }

    .title-content {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      max-width: 380px;
      overflow: hidden;

      .collection-grid {
        position: relative;
        width: 120px;
        height: 120px;
        min-width: 120px;
      }

      .img-box {
        position: relative;
        width: 120px;
        height: 120px;
        min-width: 120px;
        background-color: var(--bg-03);
        border-radius: 2px;

        &.img-box-white {
          background-color: var(--bg-01);
        }

        .likeboard-layout-wrap {
          width: 100%;
          height: 100%;
          object-fit: contain;
          margin-right: 11px;
        }
      }
    }

    .middle {
      overflow: hidden;
      width: calc(100% - 130px);
      font-weight: 400;
      color: var(--black-90);
      display: grid;
      gap: 8px;
      grid-template-rows: 1fr auto;
      height: 120px;
      padding: 8px 0;

      .collect-name-box {
        width: 100%;
        overflow: hidden;
      }

      .collect-name {
        width: 100%;
        font: var(--font-demi-14);
        margin-right: 11px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        white-space: break-spaces;
      }

      .shop {
        display: flex;
        align-items: center;
        margin: 8px 0px;
        font: var(--font-med-12);
      }

      .bottom {
        display: flex;
        gap: 8px;
        align-items: center;
      }
    }

    .badage-box {
      display: flex;
      flex-wrap: wrap;

      .my-badges-iden {
        margin-right: 8px;
        margin-bottom: 8px;
      }
    }

    .menu-td {
      position: relative;
      overflow: unset;

      .editList {
        padding: 8px 0;
        width: max-content;
        background: white;
        border: 1px solid #f2f2f2;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        position: absolute;
        z-index: 9;
        right: 0px;
        width: 150px;

        .tit {
          padding: 0 9px;
          font: var(--font-med-12);
          color: var(--black-50);
        }

        .item {
          padding: 9px 10px;
          display: flex;
          align-items: center;
          cursor: pointer;
          color: var(--black-90);
          font: unset;
          font-family: var(--font);
          font-size: 14px;

          &:hover {
            background: var(--bg-02);
          }

          .red {
            color: var(--red);
          }
        }
      }
    }

    .data-list-open-scroll {
      height: 90vh;
      overflow-y: visible;
    }
  }

  .creator-header {
    display: flex;
    align-items: center;

    .title {
      flex: 1;
      display: flex;
      align-items: center;
    }

    h2 {
      font: var(--font-demi-36);
      color: var(--Black-100);
    }

    .el-button {
      span {
        gap: 8px;
      }

      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
}

.storefront-handle-check-dialog {
  .title {
    font: var(--font-demi-20);
    color: var(--Text-primary);
    margin-bottom: 16px;
  }

  .text {
    font-size: 16px;
    color: var(--Text-primary);
    margin-bottom: 36px;
  }

  .btn-box {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .el-dialog__header {
    padding-bottom: 8px;
  }
}
</style>
